import { Link } from "react-router-dom";
import { seoArticlesList } from "@/mocks/seo-articles";

export default function ArticlesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
            Latest Guides &amp; Articles
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our collection of in-depth guides, comparisons, and tutorials to master spreadsheet-based product discovery.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticlesList.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex flex-col bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 bg-white/90 backdrop-blur-sm text-foreground-800 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-700 transition-colors duration-200 leading-snug line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1 mb-3">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span>{article.readTime} read</span>
                  <span className="flex items-center gap-1 text-primary-600 font-medium group-hover:gap-2 transition-all duration-200">
                    Read More
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/shopping-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300/60 rounded-full text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-700 transition-all duration-200 whitespace-nowrap"
          >
            View Complete Shopping Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}